import { z } from 'zod';

export const schemaEuropaceBasicResponse = z.object({
    messages: z.array(z.string()),
});

export type SchemaEuropaceBasicResponse = z.infer<typeof schemaEuropaceBasicResponse>;
